import type { ChatHistoryEntry } from "./constants";

/**
 * Hand-written stand-in for the conversation API.
 *
 * The SDK (`@lokasi-ai-web-sdk/app`) has no "list my conversations" endpoint
 * yet and cannot replay a stored conversation, so the history sidebar and the
 * conversation view read from this file instead. Delete the whole module once
 * the SDK ships those endpoints — nothing else owns dummy content.
 */

export type DummyMessageRole = "user" | "assistant";

export type DummyMessage = {
  id: string;
  role: DummyMessageRole;
  content: string;
  /**
   * Renders under a "Thinking…" label instead of a bubble, mirroring how the
   * assistant narrates its reasoning before the answer arrives.
   */
  isThinking?: boolean;
};

export type DummyConversation = {
  id: string;
  title: string;
  /** Shown under the title in the sidebar. */
  timeLabel: string;
  /** Shown above the first message in the conversation column. */
  startedAtLabel: string;
  messages: DummyMessage[];
  mapView: {
    center: [number, number];
    zoom: number;
  };
};

export const DUMMY_CONVERSATIONS: DummyConversation[] = [
  {
    id: "dummy-coffee-shop-bandung",
    title: "Potential areas for a new coffee shop in Bandung",
    timeLabel: "2 hours ago",
    startedAtLabel: "Today, 10:28 AM",
    messages: [
      {
        id: "dummy-message-1",
        role: "user",
        content: "Find potential areas for a new coffee shop in Bandung."
      },
      {
        id: "dummy-message-2",
        role: "assistant",
        isThinking: true,
        content:
          "I'm understanding the objective and identifying the information needed."
      }
    ],
    mapView: {
      center: [107.6098, -6.9175],
      zoom: 12
    }
  }
];

export const DUMMY_CHAT_HISTORY: ChatHistoryEntry[] = DUMMY_CONVERSATIONS.map(
  ({ id, title, timeLabel }) => ({ id, title, timeLabel })
);

export const findDummyConversation = (
  chatId: string | null
): DummyConversation | null =>
  DUMMY_CONVERSATIONS.find(({ id }) => id === chatId) ?? null;
